import React,{useEffect,useState} from 'react'
import { Card, CardHeader,CardBody,CardFooter,CardTitle,Row,Col,Button,Toast,ToastBody,ToastHeader} from "reactstrap";
import {ddns} from '../../../../package.json'
import UserByRoleDropdownSele from 'components/Reusable Components/UserByRoleDropdownSele';
import { merchShopBuy } from 'network/ApiAxiosMerchShop';
import ToastComp from 'components/Reusable Components/ToastComp';

function ShopCart(props) {
    useEffect(() => {
        getCart()
    }, [props.updateCartQT]);

    const [cart, setCart] = useState(false);
    const [staffBuyModal, setStaffBuyModal] = useState(false);
    const [isStaff, setIsStaff] = useState(false);
    const [toastOpen, settoastOpen] = useState(false);

    const sellerID = JSON.parse(localStorage.getItem("user"))._id

    const getCart = ()=>{
        if(localStorage.getItem('cartShop')){
            const cartStorage = JSON.parse(localStorage.getItem('cartShop'))
            setCart(cartStorage)
        }
    }
    let cartTotal =0

    const clearCart =()=>{
        localStorage.removeItem('cartShop')
        setCart(false)
    }

    const buy = async()=>{
        console.log(cart.find((cartItem)=>cartItem.staff == true))
        if(!cart) return
        if(cart.find((cartItem)=>cartItem.staff == true) && isStaff == false){
            alert('1 of the products in your cart is for staff only')
            setStaffBuyModal(true)
            return
        }
        const resp = await merchShopBuy(cart,isStaff._id,cartTotal,sellerID)
        if(resp.data.success){
            clearCart()
            settoastOpen(true)
            setIsStaff('')
            const timer = setTimeout(() => {
                settoastOpen(false);
              }, 3000);
        }else{
            alert('Something went wrong!!')
        }
    }

    const staffBuy =()=>{
        if(!cart) return
        setStaffBuyModal(true)
    }

    const freeBuy =()=>{

    }

    const handleStaff =(e)=>{//changes the prices in the cart to the staff price
        setIsStaff(JSON.parse(e))
        setCart(prevItems=>{
            return prevItems.map((cartItem)=>{
                cartItem.prod.price = cartItem.prod.priceStaff
                return {...cartItem}
            })
        })
    }

    const sizeHandler =(size)=>{
        switch (size) {
            case 'XXL':
                return '2XL'
                break;
            case 'XXXL':
                return '3XL'
                break;
            case 'XXXXL':
                return '4XL'
                break;
            default:
                return size
                break;
        }
    }

  return (
    <>
        <Card className='text-center sticky-top'>
            <CardHeader >
                <span>Cart</span>
                <Button onClick={clearCart} className='btn-danger float-right' >Clear</Button>
            </CardHeader>
            <CardBody className='justify-content-center'>
                {cart && 
                
                cart.map((cartItem)=>{
                    cartTotal = cartTotal + cartItem.qt * cartItem.prod.price
                    return<Row key={cartItem._id} className='mb-4'>
                    <Col md={4}>
                        <img
                            width='100%'
                            alt="Sample"
                            //src="https://picsum.photos/300/200"
                            src={ddns + '/userfiles/merchshop/prodimages/' + cartItem.prod.picture}
                        />
                        <span>{cartItem.qt + ' Un.'}</span><br/>
                        <span>{'Price: ' + cartItem.prod.price + '€'}</span>
                    </Col>
                    <Col md={8}>
                        <span>{cartItem.prod.house + ' ' + cartItem.prod.desc}</span><br/>
                        <span>{cartItem.prod.color}</span><br/>
                        <span>{sizeHandler(cartItem.prod.size)}</span><br/>
                        
                    </Col>
                </Row>
                })
                }
                
            </CardBody>
            <CardFooter>
                <CardTitle>{'Cart Total: ' + cartTotal}</CardTitle>
                {isStaff && <>
                    <span>{'Name: ' + isStaff.name}</span><br/>
                </>}
                <Button onClick={staffBuy} >Staff</Button>
                <Button onClick={buy}>Buy</Button>
            </CardFooter>
           <UserByRoleDropdownSele modal={staffBuyModal} toggle={setStaffBuyModal} handler={handleStaff} />

           
        </Card>
        {toastOpen && <ToastComp type='success' tittle='Purchase Done!!!' text='This purchase was successfull'/>}
    </>
  )
}

export default ShopCart